module.exports = __webpack_public_path__ + "img/f39ac6530f6156ee8081a78fffad221c.ee34fda7.png";